import { useState, useEffect, useRef } from 'react'
import { resendEmailVerification, auth } from '../../lib/auth'

interface EmailVerificationStepProps {
  onVerified: () => void
}

export default function EmailVerificationStep({ onVerified }: EmailVerificationStepProps) {
  const [resending, setResending] = useState(false)
  const [resent, setResent] = useState(false)
  const intervalRef = useRef<ReturnType<typeof setInterval>>(undefined)

  useEffect(() => {
    intervalRef.current = setInterval(async () => {
      const user = auth.currentUser
      if (user) {
        await user.reload()
        if (user.emailVerified) {
          onVerified()
        }
      }
    }, 4000)

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [onVerified])

  async function handleResend() {
    setResending(true)
    try {
      await resendEmailVerification()
      setResent(true)
      setTimeout(() => setResent(false), 5000)
    } catch {
      // ignore
    } finally {
      setResending(false)
    }
  }

  return (
    <div className="space-y-4">
      <p className="mono-label text-teal">Verify your email</p>
      <h3 className="hl text-2xl">Check your inbox</h3>
      <p className="text-sm text-navy/75 leading-relaxed">
        A verification link is on its way to{' '}
        <span className="font-semibold text-navy">{auth.currentUser?.email}</span>. Open it
        and this page updates on its own.
      </p>
      <button
        onClick={handleResend}
        disabled={resending || resent}
        className="mono-label text-amber underline underline-offset-2 disabled:opacity-50 cursor-pointer"
      >
        {resent ? 'Sent again' : resending ? 'Sending' : 'Send it again'}
      </button>
    </div>
  )
}
